import { apiClient } from './client';
import type { AdminMenuItem, MenuItemWrite, MenuNode, MenuReorderEntry, MenuRole } from '@/types/menu';

/**
 * Typed wrappers over `/api/menu*` (migration 131; SPEC §9.1). `getMenu` is any
 * signed-in user; everything else is oscar-admin only (enforced server-side).
 */

/** The caller's sidebar, already role-pruned by the server. */
export function getMenu(signal?: AbortSignal): Promise<MenuNode[]> {
  return apiClient.get<MenuNode[]>('/api/menu', signal);
}

/** The whole tree for the editor, hidden items included. */
export function getMenuAdmin(signal?: AbortSignal): Promise<AdminMenuItem[]> {
  return apiClient.get<AdminMenuItem[]>('/api/menu/admin', signal);
}

export function getMenuRoles(signal?: AbortSignal): Promise<MenuRole[]> {
  return apiClient.get<MenuRole[]>('/api/menu/roles', signal);
}

export function createMenuItem(body: MenuItemWrite): Promise<AdminMenuItem> {
  return apiClient.post<AdminMenuItem>('/api/menu/items', body);
}

export function updateMenuItem(id: number, body: MenuItemWrite & { RowVersion: string }): Promise<AdminMenuItem> {
  return apiClient.patch<AdminMenuItem>(`/api/menu/items/${id}`, body);
}

/** Soft delete. */
export function deleteMenuItem(id: number, rowVersion: string): Promise<void> {
  return apiClient.delete<void>(`/api/menu/items/${id}?RowVersion=${encodeURIComponent(rowVersion)}`);
}

export function setMenuItemRoles(id: number, rowVersion: string, roles: string[]): Promise<AdminMenuItem> {
  return apiClient.put<AdminMenuItem>(`/api/menu/items/${id}/roles`, { RowVersion: rowVersion, Roles: roles });
}

export function reorderMenu(entries: MenuReorderEntry[]): Promise<{ Updated: number }> {
  return apiClient.post<{ Updated: number }>('/api/menu/reorder', entries);
}
